import * as Message_ from './message'
import * as Template_ from './template'
import * as ArticleTemplate_ from './article-template'
import {SetSessionOnChange as SetSessionOnChange_} from './common'

export const Message = Message_
export const Template = Template_
export const ArticleTemplate = ArticleTemplate_
export const SetSessionOnChange = SetSessionOnChange_



// WEBPACK FOOTER //
// ./src/communications/communications.ts